export const paymentMethodEs = {
  Dashboard: `Panel`,
  catalog: `Catálogo`,
  payment_methods: `Métodos de pago`,
  payment_method: `Método de pago`,
  add_payment_method: `Añadir método de pago`,
  edit_payment_method: `Editar método de pago`,
  delete_payment_method: `Eliminar método de pago`,
  delete_payment_method_description: `¿Seguro que quieres eliminar este método de pago? Esta acción no se puede deshacer.`,
  code: `Código`,
  name: `Nombre`,
  actions: `Acciones`,
  search: `Buscar`,
  search_placeholder: `Buscar por código o nombre`,
  filter_payment_methods: `Filtrar métodos de pago`,
  filter_payment_methods_subtitle: `Acota la lista de métodos de pago`,
  edit: `Editar`,
  delete: `Eliminar`,
  cancel: `Cancelar`,
  add: `Añadir`,
  update: `Actualizar`,
  code_required: `El código es obligatorio`,
  name_required: `El nombre es obligatorio`,
  no_payment_methods_found: `No se encontraron métodos de pago`,
  payment_method_created_successfully: `Método de pago creado correctamente`,
  payment_method_updated_successfully: `Método de pago actualizado correctamente`,
  payment_method_deleted_successfully: `Método de pago eliminado correctamente`,
  something_went_wrong: `Algo salió mal`,
  organization_not_found: `No se encontró organización para el usuario actual`,
  payment_method_code_required: `El código del método de pago es obligatorio`,
  payment_method_name_required: `El nombre del método de pago es obligatorio`,
  payment_method_code_duplicate: `Ya existe un método de pago con este código`,
  payment_method_not_found: `Método de pago no encontrado`,
  not_allowed_to_update_payment_method: `No tienes permiso para actualizar este método de pago`,
  not_allowed_to_delete_payment_method: `No tienes permiso para eliminar este método de pago`,
  payment_method_listing_max_100_allowed: `Se pueden listar como máximo 100 métodos de pago por página`,
};
